//# sourceMappingURL=user.mjs.map
/// <reference types="./user.d.mts" />
import * as $ask from "../../../altar/altar/ask.mjs";
import * as $client from "../../../auth0_client/auth0/client.mjs";
import * as $invitation from "../../../data_types/data/auth/invitation.mjs";
import * as $user_id from "../../../data_types/data/auth/user_id.mjs";
import * as $http from "../../../gleam_http/gleam/http.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $console from "../../../tiamat/gleam/javascript/console.mjs";
import * as $result_ from "../../../tiamat/gleam/result_.mjs";
import * as $store from "../../data/store.mjs";
import { toList } from "../../gleam.mjs";

export function invite(store, invitation) {
  let token = $client.get_token_silently(store.client);
  return $promise.try_await(
    token,
    (access_token) => {
      let _pipe = $ask.to(
        new $ask.Heimdall(),
        toList(["admin", "organization", "invitation"]),
      );
      let _pipe$1 = $ask.via(_pipe, new $http.Post());
      let _pipe$2 = $ask.bearing(_pipe$1, access_token);
      let _pipe$3 = $ask.on_success(_pipe$2, (c) => { return $console.log(c); });
      let _pipe$4 = $ask.with$(_pipe$3, $invitation.encode_creation(invitation));
      let _pipe$5 = $ask.run(_pipe$4);
      return $promise.map(_pipe$5, $result_.nil_error);
    },
  );
}

export function assign_roles(store, org_id, user_id, role_ids) {
  let token = $client.get_token_silently(store.client);
  return $promise.try_await(
    token,
    (access_token) => {
      let at = toList([
        "organizations",
        org_id,
        "members",
        $user_id.to_string(user_id),
        "roles",
      ]);
      let _pipe = $ask.to(new $ask.Admin(), at);
      let _pipe$1 = $ask.via(_pipe, new $http.Post());
      let _pipe$2 = $ask.bearing(_pipe$1, access_token);
      let _pipe$3 = $ask.on_success(_pipe$2, (c) => { return $console.log(c); });
      let _pipe$4 = $ask.with$(
        _pipe$3,
        $json.object(toList([["roles", $json.array(role_ids, $json.string)]])),
      );
      let _pipe$5 = $ask.run(_pipe$4);
      return $promise.map(_pipe$5, $result_.nil_error);
    },
  );
}

export function remove_roles(store, org_id, user_id, role_ids) {
  let token = $client.get_token_silently(store.client);
  return $promise.try_await(
    token,
    (access_token) => {
      let at = toList([
        "organizations",
        org_id,
        "members",
        $user_id.to_string(user_id),
        "roles",
      ]);
      let _pipe = $ask.to(new $ask.Admin(), at);
      let _pipe$1 = $ask.via(_pipe, new $http.Delete());
      let _pipe$2 = $ask.bearing(_pipe$1, access_token);
      let _pipe$3 = $ask.on_success(_pipe$2, (c) => { return $console.log(c); });
      let _pipe$4 = $ask.with$(
        _pipe$3,
        $json.object(toList([["roles", $json.array(role_ids, $json.string)]])),
      );
      let _pipe$5 = $ask.run(_pipe$4);
      return $promise.map(_pipe$5, $result_.nil_error);
    },
  );
}
